// extracted by mini-css-extract-plugin
module.exports = {"container":"placementSrpsCard_container__1HGyI","title":"placementSrpsCard_title__1IS84","imgContainer":"placementSrpsCard_imgContainer__2Hcyu","img":"placementSrpsCard_img__1LeAf"};
    if(module.hot) {
      // 1790670302682
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  